const DIGIGO_DEV_HOST = "digigo-frontend.dev-sheba.xyz";
const DIGIGO_LOCAL_ORIGIN = "http://localhost:3001";

export const resolveLocalDigigoRedirectUri = (redirectUri: string) => {
  if (!redirectUri) return redirectUri;

  const isLocalPortal =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  if (!isLocalPortal) return redirectUri;

  try {
    const parsedRedirect = new URL(redirectUri, window.location.origin);

    if (parsedRedirect.hostname !== DIGIGO_DEV_HOST) {
      return redirectUri;
    }

    return `${DIGIGO_LOCAL_ORIGIN}${parsedRedirect.pathname}${parsedRedirect.search}${parsedRedirect.hash}`;
  } catch {
    return redirectUri;
  }
};

type BuildProductLaunchUrlParams = {
  projectType?: string;
  dynamicId?: string;
  dynamicKeyword?: string;
  token?: string;
};

export const buildProductLaunchUrl = (
  redirectUri: string,
  { projectType, dynamicId, dynamicKeyword, token }: BuildProductLaunchUrlParams
) => {
  if (!redirectUri) return redirectUri;

  try {
    const url = new URL(redirectUri, window.location.origin);

    if (projectType) url.searchParams.set("type", projectType);
    if (dynamicId) url.searchParams.set("dynamic-id", dynamicId);
    if (dynamicKeyword) url.searchParams.set("dynamic-keyword", dynamicKeyword);
    if (token) url.searchParams.set("token", token);

    return url.toString();
  } catch {
    const params = new URLSearchParams();
    if (projectType) params.set("type", projectType);
    if (dynamicId) params.set("dynamic-id", dynamicId);
    if (dynamicKeyword) params.set("dynamic-keyword", dynamicKeyword);
    if (token) params.set("token", token);
    const separator = redirectUri.includes("?") ? "&" : "?";
    return `${redirectUri}${separator}${params.toString()}`;
  }
};
